<!-- On vérifie que le rootForm existe avant de créer les champs liés -->
<div *ngIf="rootForm && listeBav && ! (modeRenduService.enModeImpression$ | async)">
  <div class="form-row mx-2 pb-3" *ngIf="rootForm && listeBav">
      <div class="col" [formGroup]="rootForm">
        <button *ngIf="modeRenduService.enModeSaisie$ | async" class="ml-n1 btn btn-info"
          (click)="ajouterBav()">Ajouter un BAV
        </button>
        <div class="col-md-12 ml-n4 mt-4">
          <bis-integer-inline-input [rootForm]="formulaire" label="xxBavNb" [max]="99" enLectureSeule="true"
            infoBulle="Cette zone est calculée automatiquement à partir du nombre de BAV ajouté(s)">
          </bis-integer-inline-input>
          <bis-affiche-alertes labelAlerte='alertDg3'></bis-affiche-alertes>
          <bis-affiche-alertes labelAlerte='alertDg4'></bis-affiche-alertes>
        </div>
        <div>
            <div class="pt-3 mb-n3"> 
              <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                labelErreur="ctrlDg5">
              </bis-affiche-erreurs-croisees>
            </div>  
            <mat-accordion class=" col-12">
              <div *ngFor="let item of listeBav.controls; let i = index">
                <mat-expansion-panel [expanded]="step === i" (opened)="setStep(i)">
                  <mat-expansion-panel-header>
                    <mat-panel-description>
                      <mat-icon>account_circle</mat-icon>&#xA0;
                      <span [ngClass]="{'onglet-invalide': listeBav.controls[i].invalid}">
                        Informations sur le BAV {{ i + 1 }}
                        <!--<span *ngIf="listeBav.controls[i].get('xxBavIelst').value">
                          : {{ listeBav.controls[i].get('xxBavIelst').value }}
                        </span>-->
                      </span>
                      <button *ngIf="(modeRenduService.enModeSaisie$ | async)" (click)="supprimerBav(i)" class="btn-danger btn-sm ml-auto"
                        title="Supprimer le Bav">
                        <i class="material-icons md-18">delete</i>
                      </button>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div class="form-row">
                      <div class="col-md-10">
                        <bis-filtered-select-input-keypad [preId]="i" [rootForm]="listeBav.controls[i]" nbChoixVisiblePossible="5" label="xxBavIelst" 
                            nomNomenclature="ielstBav" [montreCode]="false" [erreursCroisees]="['ctrlDg5']">
                        </bis-filtered-select-input-keypad>
                      </div>
                  </div>
                  <div *ngIf="xxBavIelst(i) === ''">
                    <br><br><br><br><br><br>
                  </div>
                </mat-expansion-panel>
              </div>
            </mat-accordion>
        </div>
      </div>
    </div>
</div>  


<div *ngIf="rootForm && listeBav && (modeRenduService.enModeImpression$ | async)">
  <div class="form-row mx-2 pb-3" *ngIf="rootForm && listeBav">
    <div class="col" [formGroup]="rootForm">
      <div class="col-md-12 ml-n4 mt-4">
        <bis-integer-inline-input [rootForm]="formulaire" label="xxBavNb" [max]="99" enLectureSeule="true"
          infoBulle="Cette zone est calculée automatiquement à partir du nombre de BAV ajouté(s)">
        </bis-integer-inline-input>
        <bis-affiche-alertes labelAlerte='alertDg3'></bis-affiche-alertes>
        <bis-affiche-alertes labelAlerte='alertDg4'></bis-affiche-alertes>
      </div>
      <div>
          <div class="pt-3 mb-n3"> 
            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
              labelErreur="ctrlDg5">
            </bis-affiche-erreurs-croisees>
          </div>  
          <div *ngFor="let item of listeBav.controls; let i = index">
                <div class="form-row">
                    <div class="col-md-10">
                      <bis-filtered-select-input-keypad [preId]="i" [rootForm]="listeBav.controls[i]" nbChoixVisiblePossible="5" label="xxBavIelst" 
                          nomNomenclature="ielstBav" libelle="vide" [montreCode]="false" [erreursCroisees]="['ctrlDg5']">
                      </bis-filtered-select-input-keypad>
                    </div>
                </div>
            </div>
          </div>
      </div>
  </div>
</div>

